import { useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { api } from "../lib/api";
import { money, num, run, useLoad } from "../lib/util";
import { Badge, Btn, Card, Field, Input, Select, Empty } from "../components/kit";

function PlanDialog({ initial, onClose, onSaved }) {
  const [f, setF] = useState({ name: "", price: "", period: "mensal", description: "", features: "", active: true, order: 0, ...initial, features: (initial.features || []).join("\n") });
  const save = async () => {
    const body = { ...f, price: num(f.price), order: Number(f.order) || 0, description: f.description || null, features: f.features.split("\n").map((x) => x.trim()).filter(Boolean) };
    delete body.id;
    delete body.created_at;
    if (await run(() => (f.id ? api.put(`/admin/plans/${f.id}`, body) : api.post("/admin/plans", body)), "Plano salvo")) {
      onSaved();
      onClose();
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="plan-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Editar plano" : "Novo plano"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Nome" className="col-span-2"><Input data-testid="plan-name-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
          <Field label="Valor (R$) — vazio = sob consulta"><Input data-testid="plan-price-input" value={f.price ?? ""} onChange={(e) => setF({ ...f, price: e.target.value })} /></Field>
          <Field label="Período"><Select data-testid="plan-period-select" value={f.period} onChange={(e) => setF({ ...f, period: e.target.value })} options={[["mensal", "Mensal"], ["trimestral", "Trimestral"], ["semestral", "Semestral"], ["anual", "Anual"]]} /></Field>
          <Field label="Descrição" className="col-span-2"><Input data-testid="plan-description-input" value={f.description || ""} onChange={(e) => setF({ ...f, description: e.target.value })} /></Field>
          <Field label="Itens incluídos (um por linha)" className="col-span-2"><textarea data-testid="plan-features-input" rows={4} className="w-full rounded-lg border border-slate-300 p-2 text-sm" value={f.features} onChange={(e) => setF({ ...f, features: e.target.value })} /></Field>
          <Field label="Ordem"><Input type="number" value={f.order} onChange={(e) => setF({ ...f, order: e.target.value })} /></Field>
          <label className="flex items-center gap-2 text-sm mt-5"><input type="checkbox" data-testid="plan-active-checkbox" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} />Exibir no site</label>
        </div>
        <DialogFooter>
          <Btn variant="outline" onClick={onClose}>Cancelar</Btn>
          <Btn data-testid="plan-save-button" onClick={save}>Salvar</Btn>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default function PlansTab() {
  const [plans, reload] = useLoad(async () => (await api.get("/admin/plans")).data, []);
  const [edit, setEdit] = useState(null);
  const del = async (p) => {
    if (window.confirm(`Remover o plano ${p.name}?`) && (await run(() => api.delete(`/admin/plans/${p.id}`), "Plano removido"))) reload();
  };
  return (
    <div className="mt-4 space-y-4">
      <div className="flex justify-between items-center">
        <p className="text-sm text-slate-500">Os planos ativos aparecem na página de vendas com os valores definidos aqui.</p>
        <Btn data-testid="new-plan-button" onClick={() => setEdit({})}><Plus className="w-4 h-4" />Novo plano</Btn>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {(plans || []).map((p) => (
          <Card key={p.id} data-testid={`plan-admin-${p.name}`}>
            <div className="flex justify-between items-start">
              <h3 className="font-heading text-lg font-bold">{p.name}</h3>
              <Badge tone={p.active ? "green" : "muted"}>{p.active ? "No site" : "Oculto"}</Badge>
            </div>
            <div className="font-heading text-2xl font-extrabold text-[#FF6500] mt-2">{p.price != null ? money(p.price) : "Sob consulta"} <span className="text-xs text-slate-500">/{p.period}</span></div>
            <ul className="text-sm text-slate-600 mt-3 list-disc pl-5">{p.features.map((x) => <li key={x}>{x}</li>)}</ul>
            <div className="flex gap-2 mt-4">
              <Btn variant="outline" onClick={() => setEdit(p)}><Pencil className="w-4 h-4" />Editar</Btn>
              <Btn variant="danger" onClick={() => del(p)}><Trash2 className="w-4 h-4" /></Btn>
            </div>
          </Card>
        ))}
      </div>
      {plans && !plans.length && <Empty>Nenhum plano criado. A página de vendas mostrará “Planos em definição”.</Empty>}
      {edit && <PlanDialog initial={edit} onClose={() => setEdit(null)} onSaved={reload} />}
    </div>
  );
}
